import * as user from './user'
import * as device from './device'
import * as staff from './staff'
import * as type from './type'
import * as order from './order'
import * as recharge from './recharge'

export default {
    user, device, type, staff, order, recharge
}


// WEBPACK FOOTER //
// ./src/services/api/shop/index.js